import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-paginator',
	imports: [SharedModule],
	templateUrl: './paginator.component.html',
	styleUrl: './paginator.component.scss',
})
export class PaginatorComponent {
	@Input() totalRecords = 0;
	@Input() rows = 10;
	@Input() size: 'small' | 'large' = 'large';

	@Output() onPageChange = new EventEmitter<any>();

	first = 0;
	Math = Math; // Make Math available in template

	// Options for rows per page
	rowsPerPageOptions = [
		{ label: '10', value: 10 },
		{ label: '25', value: 25 },
		{ label: '50', value: 50 },
	];

	onRowsChange(event: any): void {
		this.rows = event.value;
		this.first = 0; // Reset to first page when changing rows per page
		this.onPageChange.emit({
			first: this.first,
			rows: this.rows,
			page: 0,
			pageCount: Math.ceil(this.totalRecords / this.rows),
		});
	}

	previousPage(): void {
		if (this.first > 0) {
			this.first = Math.max(0, this.first - this.rows);
			this.onPageChange.emit({
				first: this.first,
				rows: this.rows,
				page: this.first / this.rows,
				pageCount: Math.ceil(this.totalRecords / this.rows),
			});
		}
	}

	nextPage(): void {
		if (this.first + this.rows < this.totalRecords) {
			this.first = this.first + this.rows;
			this.onPageChange.emit({
				first: this.first,
				rows: this.rows,
				page: this.first / this.rows,
				pageCount: Math.ceil(this.totalRecords / this.rows),
			});
		}
	}
}
